import { createSlice } from "@reduxjs/toolkit";
import { postLoginUser, refreshLoginUser } from "./authApi";

interface AuthState {
    isAuthenticated: boolean;
    loginUser: any;
    isLoading: boolean;
    error: any;
}

const initialState: AuthState = {
    isAuthenticated: false,
    loginUser: null,
    isLoading: false,
    error: null
}

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postLoginUser.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(postLoginUser.fulfilled, (state, action) => {
                state.isLoading = false;
                state.loginUser = action?.payload?.data;
            })
            .addCase(postLoginUser.rejected, (state, action) => {
                console.log('error', action.payload)
                state.isLoading = false;
            })
            .addCase(refreshLoginUser.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(refreshLoginUser.fulfilled, (state, action) => {
                state.isLoading = false;
                state.loginUser = action?.payload?.data;
            })
            .addCase(refreshLoginUser.rejected, (state, action) => {
                console.log('error', action.payload)
                state.isLoading = false;
            });
    }
});

export default authSlice.reducer;